import styled from '../styled';
export default styled.form.attrs({ name: 'form' })`
    display: flex;
    flex-direction: column;
`;
